"use client";

import Cookies from "js-cookie";

const COOKIE_NAMES_TO_CLEAR = [
    "authToken",
    "userData",
    "lastActivity",
    "source_t",
];

const STORAGE_KEYS_TO_CLEAR = [
    "leadNumber",
    "userCode",
    "cart",
    "preventivoVehicle",
    "source_t",
];

export const clearOperatorSessionArtifacts = () => {
    COOKIE_NAMES_TO_CLEAR.forEach((cookieName) => {
        Cookies.remove(cookieName, { path: "/" });
    });

    if (typeof window === "undefined") {
        return;
    }

    STORAGE_KEYS_TO_CLEAR.forEach((storageKey) => {
        try {
            window.sessionStorage.removeItem(storageKey);
            window.localStorage.removeItem(storageKey);
        } catch {
            // Ignore storage access errors.
        }
    });

    try {
        window.dispatchEvent(new CustomEvent("cart-updated", { detail: [] }));
    } catch {
        // Ignore event dispatch errors.
    }
};

export const clearAuthNavigationArtifacts = async () => {
    try {
        await fetch("/api/auth/logout-cleanup", {
            method: "POST",
            credentials: "include",
        });
    } catch {
        // Local cleanup still runs when the server cleanup is unavailable.
    }

    clearOperatorSessionArtifacts();
};
